import AdminAnalytics from '../group/AdminAnalytics';

export default function DRRMODashboard() {
  return <AdminAnalytics pageMode="drrmo" />;
}
